import { Box, Typography } from '@mui/material'

import { ArtistBannerDetailFragment, Maybe } from '@/clients/utoniq-core/schema'
import { BaseLayout, Head } from '@/components/layouts'
import { FileUploadInfo } from '@/components/pages/ConsoleCollectionCreate/template/CollectionCreateForm'
import { ArtistThemeProvider } from '@/components/styles'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

import {
  ConsoleCampaignBannerSettingForm,
  ConsoleCampaignBannerSettingFormProps,
} from './ConsoleCampaignBannerSettingForm'

export * from './fragments'

export type State = {
  artistId: string
  progress: number
  loading: boolean
  bannerSettings: Maybe<ArtistBannerDetailFragment[]>
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onDrop: FileUploadInfo['onDrop']
  onSubmit: ConsoleCampaignBannerSettingFormProps['onSubmit']
}

export const ConsoleCampaignBannerSettingTemplate: Template<State, Action> = ({
  state,
  onDrop,
  onSubmit,
}) => {
  const { t } = useTranslation('consoleCampaignBannerSetting')
  const { routerNames, routerPages } = useRouter()
  return (
    <ArtistThemeProvider artistId={state.artistId}>
      <Head title={routerNames.ConsoleCampaignBannerSetting} />
      <BaseLayout
        margin
        header={{
          back: true,
          defaultBackPage: routerPages.ConsoleDashboard,
          title: t('title'),
        }}
      >
        <Box sx={{ pt: 5, pb: 4 }}>
          <Typography variant="body2">
            {t(
              'campaignBannerSettingDesc',
              'サービストップ画面に表示するバナーを最大3つまで登録することができます。'
            )}
          </Typography>
        </Box>
        <ConsoleCampaignBannerSettingForm
          loading={state.loading}
          bannerSettings={state.bannerSettings}
          fileUploadInfo={{ progress: state.progress, onDrop }}
          onSubmit={onSubmit}
        />
      </BaseLayout>
    </ArtistThemeProvider>
  )
}
